import Link from 'next/link';
import styled from 'styled-components';

export const DefaultError = () => (
  <DefaultError.Wrapper>
    <p>Sorry, something went wrong.</p>
    <p>
      Please, contact&nbsp;
      <Link href="https://goat.zendesk.com/hc/en-us">Support</Link>.
    </p>
  </DefaultError.Wrapper>
);

DefaultError.Wrapper = styled.div`
  text-align: center;
`;
